// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"0ef72a0ecfb16f8d","573":"b18f60b1d2eda0e5","646":"120e26959f6d7237"}[chunkId] + ".js";
};